/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@material-ui/core";
import { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import userReservationStyles from "../../../assests/styles/views/public/userReservation";
import { getTranslation } from "../../../heplers/translationHelper";
import authService from "../../../utils/authUtils";
import LanguageSelector from "../component/languageSelector";
import UserReservationLayout from "../component/Layout";
import Navbar from "../component/Navbar";
import { ReservationForm } from "../component/ReservationForm";
import { Get_Reservation_URL, Get_Logo_URL } from "../../../constants/apiUrls";
import { useState } from "react";
import { Get, GetFile } from "../../../actions";
import LogoFile1 from "../../../assests/images/restobizLogo.png";

const UserReservation = ({ enableLogo }) => {
	const params = useParams();
	const { customerId, primaryColor, secondaryColor, reservationId } = params;
	const setCustomerId = authService.setCustomerId;
	const [selectedReservation, setSelectedReservaton] = useState();
	const [loading, setLoading] = useState(false);
	const [src, setSrc] = useState("");
	const history = useHistory();
	const isStaff = authService.isAuthenticated();
	// a staff member opened a customer's edit link: offer the staff edit screen instead
	const [showStaffNotice] = useState(() => isStaff && !!reservationId);
	// the API finds the restaurant from this id; save it before the child components send their first requests
	useState(() => {
		if (!isStaff) setCustomerId(customerId);
	});
	useEffect(() => {
		if (reservationId) {
			setLoading(true);

			Get(
				{
					id: reservationId,
				},
				Get_Reservation_URL,
				null,
				(res) => {
					res.data.oldPersons = res?.data.persons;
				    setSelectedReservaton(res.data);
					setLoading(false);
				},
				(err) => {
					setLoading(false);
				}
			);
		}
	}, [reservationId]);
	

	useEffect(() => {
		setLoading(true);
		Get(
			{},
			Get_Logo_URL,
			null,
			(res) => {
				setLoading(false);
				if(res?.data)
					setSrc(GetFile(res.data));
				else
					setSrc(LogoFile1);
			},
			(err) => {
				setLoading(false);
			}
		);
	}, []);
	const classes = userReservationStyles({
		primaryColor: "#" + primaryColor,
		secondaryColor: "#" + secondaryColor,
	});

	return (
		<>
			<UserReservationLayout
				classes={classes}
				disabled={false}
				enableLogo={enableLogo}
			>
				<div className={classes.formWrapper}>
					<Grid item sm={12} xs={12}>
					
						{enableLogo ? (
							src ? (
								<div
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "center",
										marginTop: "10px",
									}}
								>
									<div
										style={{
											width: "200px",
											height: "150px",
										}}
									>
										<img
											alt="Logo"
											src={src}
											style={{ width: "100%", height: "100%" }}
										/>
									</div>
								</div>
							) : (
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										marginTop: "10px",
										width: "100%",
									}}
								>
									
								</div>
							)
						) : null}
					</Grid>
					{reservationId && !selectedReservation ? (
						<Box display="flex" justifyContent="center" mt={4}>
							<CircularProgress />
						</Box>
					) : (
						<ReservationForm
							disabled={false}
							classes={classes}
							isEdit={selectedReservation}
							selectedData={selectedReservation}
							onlineReservationRefresh={() => window.location.reload()}
						/>
					)}
				</div>
			</UserReservationLayout>
			<Dialog open={showStaffNotice} onClose={() => {}} disableEscapeKeyDown maxWidth="sm" fullWidth>
				<DialogTitle>{getTranslation("Link for customers")}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{getTranslation("This link is for customers, but we noticed you are already logged in as a staff member. The system can redirect you to the staff edit screen of this reservation.")}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						variant="contained"
						color="primary"
						onClick={() => history.replace('/customer/reservations', { editReservationId: reservationId })}
					>
						{getTranslation("Redirect to Staff")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default UserReservation;
